export default __webpack_public_path__ + "static/do-meaning-image-b33675022822579b3e88c87f4925510b2eb0ad3c69107aceca0d1f55777f1d8d.png";